<script setup>
import Title from '../elements/Title.vue'

const linkUrl = 'https://joe.nl/reis-mee-met-de-joe-singalong-trein'
</script>

<template>
  <div class="-mx-4 my-4">
    <div class="w-full h-4 bg-white" />
  </div>
  <a :href="linkUrl">
    <div class="text-center space-y-4 -m-4 p-4 hover:bg-gray-200">
      <img
        src="https://cdn-radio.dpgmedia.net/7/6a/d9/a0/1598375/SINGALONG-BUTTON_cropped__1__34f30926d5.png"
        alt="Reis mee met de JOE Singalong Trein"
        class="w-48 mx-auto"
      />

      <div class="space-y-1">
        <Title>Mee met de Singalong Trein?</Title>

        <p>
          Wil jij op <strong>6 februari</strong> meereizen met de Singalong Trein? Geef je
          <a :href="linkUrl" class="underline text-accent">hier</a> op en maak kans op deze speciale treinkaartjes!
        </p>
      </div>
    </div>
  </a>
</template>
